import { cn } from '@core/utils';
import type { CSSProperties } from 'react';

import styles from './Rating.module.scss';

//* Rating.module.scss가 --star-gap으로 읽어 마스크 타일 폭을 잡는다
const STAR_GAP = 2;

interface RatingProps {
  value: number;
  count?: number;
  size?: number;
  /** 그릴 별 개수. 시안이 평점 요약을 별 1개로 표현하는 화면에서 1을 넘긴다. */
  starCount?: number;
  className?: string;
  contentClassName?: {
    count?: string;
  };
}

export const Rating = ({
  value,
  count,
  size = 12,
  starCount = 5,
  className,
  contentClassName,
}: RatingProps) => {
  const ratingLabel =
    count !== undefined
      ? `5점 만점에 ${value}점, 리뷰 ${count.toLocaleString()}개`
      : `5점 만점에 ${value}점`;

  const clampedValue = Math.max(0, Math.min(starCount, value));
  //* 꽉 찬 별 사이의 간격도 채워야 경계가 다음 별 앞에 선다. 마지막 별 뒤 간격은 트랙 밖이라 뺀다
  const fillWidth =
    clampedValue * size +
    Math.min(Math.floor(clampedValue), starCount - 1) * STAR_GAP;

  return (
    <div className={cn('flex items-center', className)}>
      <span
        aria-label={ratingLabel}
        className={cn(
          styles.rating,
          '[--star-off:theme(colors.Gray.400)] [--star-on:theme(colors.Y.550)]',
        )}
        role="img"
        style={
          {
            '--star-count': starCount,
            '--star-fill': `${fillWidth}px`,
            '--star-gap': `${STAR_GAP}px`,
            '--star-size': `${size}px`,
          } as CSSProperties
        }
      />
      {count !== undefined && (
        <span
          aria-hidden="true"
          className={cn(
            'ml-4 font-400 text-Gray-600 typo-caption2',
            contentClassName?.count,
          )}
        >
          ({count.toLocaleString()})
        </span>
      )}
    </div>
  );
};
